<template>
    <div
        style="display: inline-block;"
    >
        <template v-if="show_open_data">
            <template v-if="app_use_open_data && useOpenData">
                <Opendata :type="type" :openid="openid" :name="name"/>
            </template>
            <template v-else>
                {{name  | userDepartment}}
            </template>
        </template>
    </div>

</template>
<script>
import Opendata from './opendata.vue'
export default {
    data(){
        return {
            show_open_data: false,
            app_use_open_data: true
        }
    },
    props: ["type", "openid", "useOpenData","name"],
    components:{
        Opendata
    },
    filters:{
        userDepartment : value => {
            if (!!value) {
                return typeof value == 'string' ? value : value[0].substr(0,8)
            }
        }
    },
    mounted() {
     this.show_open_data = window.show_open_data;
        this.app_use_open_data = window.use_open_data;
    },
};
</script>
<style lang="scss" scoped>
.depa_nowrap {
    width: 2.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>